<ng-container *ngFor="let message of messages$ | async">
  <mnz-messageRenderer [message]="message" (close)="onCloseMessage($event)" [class]='messageClass'></mnz-messageRenderer>
</ng-container>
